import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './PropertyCard.module.css';

const BG = [
  'linear-gradient(135deg,#1E2533,#2A3244)',
  'linear-gradient(135deg,#1A2530,#1E3040)',
  'linear-gradient(135deg,#1A2520,#1E3028)',
  'linear-gradient(135deg,#251A20,#302025)',
  'linear-gradient(135deg,#1A1E30,#1E2540)',
  'linear-gradient(135deg,#1E2520,#252E22)',
];
const EMOJIS = ['🏢','🌇','🏡','🏗️','🌃','🏘️'];
const BADGE_LABELS = { sprzedaz: 'Sprzedaż', wynajem: 'Wynajem', nowe: 'Nowe' };

function formatPrice(price, unit) {
  if (price >= 1000000) return (price/1000000).toFixed(2).replace('.',',')+' mln zł';
  return price.toLocaleString('pl-PL')+' zł';
}
function timeAgo(d) {
  const h = Math.floor((Date.now()-new Date(d))/3600000);
  if (h<1) return 'Przed chwilą'; if (h<24) return 'Dziś';
  const days = Math.floor(h/24);
  if (days===1) return 'Wczoraj'; if (days<7) return `${days} dni temu`;
  return `${Math.floor(days/7)} tyg. temu`;
}

export default function PropertyCard({ listing, index = 0 }) {
  const [liked, setLiked] = useState(false);
  const mainImage = listing.images?.find(i => i.isMain) || listing.images?.[0];
  const hasPhoto = mainImage?.url;

  return (
    <div className={styles.card}>
      <Link to={`/ogloszenia/${listing.slug || listing.id}`} className={styles.imgWrap}>
        {hasPhoto ? (
          <img src={mainImage.url} alt={listing.title} className={styles.realImg} />
        ) : (
          <div className={styles.imgInner} style={{ background: BG[index % BG.length] }}>
            <span className={styles.emoji}>{EMOJIS[index % EMOJIS.length]}</span>
          </div>
        )}
        <span className={`${styles.badge} ${styles['badge_'+listing.type]}`}>
          {BADGE_LABELS[listing.type]}
        </span>
        {listing.images?.length > 1 && (
          <span className={styles.photoCount}>📷 {listing.images.length}</span>
        )}
      </Link>
      <button className={styles.heart} onClick={() => setLiked(l=>!l)}>{liked?'❤️':'🤍'}</button>
      <Link to={`/ogloszenia/${listing.slug || listing.id}`} className={styles.body}>
        <div className={styles.price}>
          {formatPrice(listing.price)}{listing.priceUnit && <span className={styles.priceUnit}> {listing.priceUnit}</span>}
        </div>
        <div className={styles.title}>{listing.title}</div>
        <div className={styles.location}>{listing.location}</div>
        <div className={styles.features}>
          <span><strong>{listing.area}</strong> m²</span>
          <span><strong>{listing.rooms}</strong> pok.</span>
          <span>{listing.floor}</span>
          <span className={styles.age}>{timeAgo(listing.createdAt)}</span>
        </div>
      </Link>
    </div>
  );
}
